export const H_PADDING_MOBILE = '24px';

export const CONTENT_MAX_WIDTH = 990;

export const IMAGE_HEIGHTS = {
  small: { mobile: 240, desktop: 360 },
  medium: { mobile: 320, desktop: 480 },
  large: { mobile: 400, desktop: 600 },
};

export const ORIENTATION_RATIOS = {
  portrait: 3 / 4,
  album: 16 / 9,
};

export function getImageHeight(size) {
  return IMAGE_HEIGHTS[size] || null;
}

export const SECTION_SPACING = {
  small: { mobile: 24, desktop: 40 },
  medium: { mobile: 40, desktop: 64 },
  large: { mobile: 64, desktop: 120 },
};

export function getSectionSpacing(size) {
  return SECTION_SPACING[size] || SECTION_SPACING.medium;
}
